import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppService } from '../app.service';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(
    private toastr: ToastrService,
    private appService: AppService
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError(err => {
        let errorMessage = '';

        let userMsg = 'Something went wrong, please try again later or contact your administrator if problem presists';

        if (err.status == 401 && err.url.indexOf('/login') > -1) return;

        if (err.status == 401) {
          this.showErrorMsg('Unauthorized, please login again.')
          this.appService.logout();
        }
        //else {
        //  userMsg = err.error.detail || userMsg;
        //  errorMessage = `Error Code: ${err.status}, Message: ${userMsg}`;
        //  this.showErrorMsg(errorMessage);
        //}


        return throwError(err)
      })
    );
  }

  showErrorMsg(msg: string) {
    this.toastr.error(msg, 'Error!');
  }
}
